import { css } from '@emotion/react';
import { ReactElement } from 'react';
import { ChatSuggestion } from 'sdk';

import { styled } from '../../../../../styled';
import { Suggestion } from './suggestion';

type Interface = {
	className: string;
	suggestions: ChatSuggestion[];
	onSuggestionSelect: (text: string) => void;
};

const styles = css`
	cursor: pointer;
	left: 0;
	user-select: none;
	width: 100%;

	& > * {
		border-bottom: 1px solid rgba(34, 43, 85, 0.16);
	}

	& > *:first-of-type {
		border-top: 1px solid rgba(34, 43, 85, 0.16);
	}
`;

const Component = ({ className, suggestions, onSuggestionSelect }: Interface): ReactElement => {
	//const { containerRef, styles } = useSizes();
	return (
		<div className={className}>
			{Object.values(suggestions).map((v) => (
				<Suggestion onClick={(): void => onSuggestionSelect(v.text || '')} key={v.text} suggestion={v} />
			))}
		</div>
	);
};

export const Suggestions = styled(Component)(styles);
